import { render, staticRenderFns } from "./QuickIconButton.vue?vue&type=template&id=54b87b66&scoped=true"
import script from "./QuickIconButton.vue?vue&type=script&lang=js"
export * from "./QuickIconButton.vue?vue&type=script&lang=js"
import style0 from "./QuickIconButton.vue?vue&type=style&index=0&id=54b87b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b87b66",
  null
  
)

export default component.exports